<template>
  <div class="wrapper">
     <van-uploader :after-read="upload" accept="image/*" style="width: 100%;">
      <div class="topHead">
        <div style="display:flex;align-items: center;">
          <img v-if="!info.head_pic" style="border:0; background: #fff;" src="./../../assets/images/information/morentouxiang.png" class="pic" alt="">
          <img v-else :src="info.head_pic" alt class="pic" />
          <span>设置头像</span>
        </div>
        <img src="./../../assets/images/index/img_back.png" alt class="back" />
      </div>
     </van-uploader>
     <div class="item">
       <span>修改昵称</span>
       <input type="text" v-model="info.nick_name" placeholder="设置昵称" />
     </div>
     <div class="btn" @click="save"><span>保存</span></div>
  </div>
</template>

<script>
import weChatShareApi from "../../assets/js/weChatShare";
import { dataURLtoFile, photoCompress } from "../../assets/js/tool";
import OSS from "ali-oss";
import ObsClient from "esdk-obs-browserjs/src/obs";
export default {
  components: {},
  props: {},
  mixins: [weChatShareApi],
  data() {
    return {
      info:{

      },
    }
  },
  methods: {
     upload(file) {
      const that = this;
      let toast = this.$toast.loading({
        duration: 0
      });
      let quality = Number((1048576 / file.file.size).toFixed(1)); //压缩到1m以内  算出压缩比例
      photoCompress(file.file, callback, quality); //将图片进行压缩
      function callback(res) {
        let newFile = dataURLtoFile(res, file.file.name);
        let url = that.uploadPath("images/user", newFile);
        if(that.uplaodServer=='aliyun'){
        that.$post("/api/customer/getOSSToken", {
            userNbr: that.userInfo.nbr,
            token: "123456"
          })
          .then(data => {
            let OSSToken = data.object.resp;
            if (OSSToken.resp_code == 0 && OSSToken.resp_result == 0) {
              let client = new OSS({
                //            region: '购买的区域',
                endpoint: OSSToken.endpoint,
                bucket: OSSToken.bucketName,
                accessKeyId: OSSToken.accessKeyId,
                accessKeySecret: OSSToken.accessKeySecret,
                stsToken: OSSToken.securityToken
              });
              client.options.endpoint.protocol = "https:";
              client
                .put(url, newFile)
                .then(data => {
                  let imgUrl = that.cdnImgPath + '/' + data.name;
                  that.info.head_pic = imgUrl;
                  that.$forceUpdate();
                  toast.clear();
                })
                .catch(error => {
                  toast.clear();
                  that.$toast({
                    message: "上传失败",
                    duration: 2000
                  });
                });
            } else {
              that.$toast({
                message: OSSToken.resp_msg,
                duration: 2000
              });
            }
          })
          .catch(err => {
            that.$toast({
              message: err.message,
              duration: 2000
            });
          });
        }else{
          that.$post("/api/customer/getObsToken", {
            userNbr: that.userInfo.nbr,
            token: "123456",
          })
          .then((data) => {
            let OBSToken = data.object.resp;
            if (OBSToken.resp_code == 0 && OBSToken.resp_result == 0) {
              let client = new ObsClient({
                access_key_id: OBSToken.accessKeyId,
                secret_access_key: OBSToken.accessKeySecret,
                server: OBSToken.endpoint,
                security_token: OBSToken.securityToken,
                timeout: 3000, // 设置超时时间
              });
              client.putObject(
                {
                  Bucket: OBSToken.bucketName, // 桶名
                  Key: url, // 文件名
                  SourceFile: newFile,
                },
                function (err, result) {
                  if (err) {
                    toast.clear();
                    that.$toast({
                      message: "上传失败",
                      duration: 2000,
                    });
                  } else {
                    if (result.CommonMsg.Status < 300) {
                      let imgUrl = that.cdnImgPath + "/" + url;
                      that.info.head_pic = imgUrl;
                      that.$forceUpdate();
                      toast.clear();
                    }
                  }
                }
              );
            } else {
              that.$toast({
                message: OBSToken.resp_msg,
                duration: 2000,
              });
            }
          })
          .catch((err) => {
            that.$toast({
              message: err.message,
              duration: 2000,
            });
          });
        }
      }
    },
    uploadPath(path, file) {
      //let name = file.name.replace("wxfile://", "");
      return `${path}/${this.userInfo.nbr}-${new Date().getTime()}.${
        file.type.split("/")[1]
      }`;
    },
    save(){
      if(this.info.nick_name&&this.info.head_pic){
        this.$commonPost({
          jydm: "flow_10000",
          flow_10000: {
            sub_flow:'flow_10082',
            user_nbr: this.userInfo.nbr,
            nick_name: this.info.nick_name,
            head_pic: this.info.head_pic,
          }
        })
          .then(resp => {
            this.$toast({
              message:'保存成功',
              duration: 2000,
            })
            this.$router.go(-1)
          })
          .catch(err => {
            this.$toast({
              message: err.message,
              duration: 2000
            });
          });
      }else{
        this.$toast({
          message:'请先填写',
          duration: 2000,
        })
      }
    }
  },
  mounted() {
    document.title = '个人信息'
    this.$commonPost({
      jydm: "flow_10003",
      flow_10003: {
        user_nbr: this.userInfo.nbr
      }
    })
      .then(resp => {
        this.info = resp;
      })
      .catch(err => {
        this.$toast({
          message: err.message,
          duration: 2000
        });
      });
  },
}
</script>

<style scoped lang='less'>
.wrapper{
  width: 100%;
  min-height: 100vh;
  background: #f5f5f5;
}
.topHead{
  width: 100%;
  height: 1.36rem;
  background: #fff;
  display: flex;
  align-items: center;
  padding: 0 .24rem;
  box-sizing: border-box;
  justify-content: space-between;
}
.pic{
  width: .96rem;
  height: .96rem;
  border-radius: 50%;
  margin-right: .29rem;
}
.topHead span{
  font-size: .3rem;
  color: #333333;
  font-weight: 500;
}
.topHead .back{
  width: 0.44rem;
  height: 0.44rem;
}
.item{
  height: .98rem;
  width: 100%;
  background: #fff;
  margin-top: .2rem;
  display: flex;
  align-items: center;
  padding: 0 .24rem;
  box-sizing: border-box;
  justify-content: space-between;
  span{
    font-size: .3rem;
    color: #333;
    font-weight: 500;
  }
  input{
    font-size: .3rem;
    color: #333;
    font-weight: 500;
    border: none;
    flex: 1;
    margin-left: .2rem;
    text-align: right;
  }
  .back{
    width: 0.44rem;
    height: 0.44rem;
  }
}
.btn{
  position: absolute;
  bottom: .32rem;
  left: 50%;
  transform: translateX(-50%);
  width: 6.88rem;
  height: 0.88rem;
  border-radius: .04rem;
  background: #FF3B30;
  display: flex;
  justify-content: center;
  align-items: center;
  span{
    font-size: 0.3rem;
    color: #fff;
    font-weight: 500;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/information/editInfo.vue